import React, { useState } from 'react';
import axios from "axios";
import { API_BASE_URL } from '../config';
import styles from './Contact.module.css';

export const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: ""
  });
  const [showSuccess, setShowSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const { firstName, lastName, email, phone, message } = formData;

  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    // Guard against multiple clicks
    if (isSubmitting) return;

    setIsSubmitting(true);
    setErrorMessage("");

    try {
      const response = await axios.post(`${API_BASE_URL}/api/query`, {
        fullName: `${firstName} ${lastName}`.trim(),
        email,
        phone,
        message,
      });

      if (response.status === 200 || response.status === 201 || response.data?.success) {
        setShowSuccess(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: ""
        });
      } else {
        setErrorMessage("Failed to submit query. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting query:", error);
      setErrorMessage(
        error.response?.data?.message || "Failed to submit query. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.page}>
      <section className={styles.hero}>
        <div className="container">
          <h1 className="section-title" style={{ textAlign: 'center' }}>
            Reach Out To Us By <span style={{ color: 'var(--black)' }}>Filling This Form</span>
          </h1>
        </div>
      </section>

      <section className={styles.body}>
        <div className="container">
          <div className={styles.grid}>

            {/* Form */}
            <div className={styles.formWrap}>
              {showSuccess ? (
                <div className={styles.success}>
                  <span className={styles.successIcon}>
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </span>
                  <h3>Query Submitted Successfully!</h3>
                  <p>Thank you for reaching out. Our team has received your message and will get back to you shortly.</p>
                  <button 
                    type="button" 
                    className="btn btn-red" 
                    onClick={() => setShowSuccess(false)}
                    style={{ marginTop: '12px' }}
                  >
                    Send Another Message
                  </button>
                </div>
              ) : (
                <form className={styles.form} onSubmit={handleOnSubmit}>
                  {errorMessage && (
                    <div style={{
                      padding: '12px 16px',
                      background: '#fee2e2',
                      border: '1px solid #f87171',
                      borderRadius: '8px',
                      color: '#b91c1c',
                      fontSize: '14px'
                    }}>
                      {errorMessage}
                    </div>
                  )}

                  <div className={styles.row}>
                    <div className={styles.field}>
                      <label>First Name</label>
                      <input
                        name="firstName"
                        value={firstName}
                        onChange={handleOnChange}
                        placeholder="First Name"
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                    <div className={styles.field}>
                      <label>Last Name</label>
                      <input
                        name="lastName"
                        value={lastName}
                        onChange={handleOnChange}
                        placeholder="Last Name"
                        required
                        disabled={isSubmitting}
                      />
                    </div>
                  </div>
                  <div className={styles.field}>
                    <label>Email</label>
                    <input
                      name="email"
                      type="email"
                      value={email}
                      onChange={handleOnChange}
                      placeholder="john@example.com"
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className={styles.field}>
                    <label>Phone Number</label>
                    <input
                      name="phone"
                      type="tel"
                      value={phone}
                      onChange={handleOnChange}
                      placeholder="+91 ()"
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                  <div className={styles.field}>
                    <label>Queries</label>
                    <textarea
                      name="message"
                      value={message}
                      onChange={handleOnChange}
                      placeholder="Tell us about your project"
                      rows={5}
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                  <button 
                    type="submit" 
                    className={`btn btn-red ${styles.submitBtn}`}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className={styles.spinner}>
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <circle cx="12" cy="12" r="10" strokeOpacity="0.25"></circle>
                            <path d="M12 2a10 10 0 0 1 10 10" strokeLinecap="round"></path>
                          </svg>
                        </span>
                        Sending Message...
                      </>
                    ) : (
                      'Send Message'
                    )}
                  </button>
                </form>
              )}
            </div>

            {/* Map Placeholder */}
            <div className={styles.mapWrap}>
              <div className={styles.mapContainer}>
                <iframe
                  title="TSIL Office Location"
                  src="https://maps.google.com/maps?q=609%20Tower%20II%20Pearls%20Omaxe%20NSP%20Pitampura%20New%20Delhi%20110034&t=&z=15&ie=UTF8&iwloc=&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </div>

              <div className={styles.info}>
                <div className={styles.infoItem}>
                  <strong>Email</strong>
                  <span>team@tsil.net.in</span>
                </div>
                <div className={styles.infoItem}>
                  <strong>Phone</strong>
                  <span>+91-96618 29944</span>
                </div>
                <div className={styles.infoItem}>
                  <strong>Office</strong>
                  <span>609, Tower II, Pearls Omaxe, NSP, Pitampura, New Delhi - 110034</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
